import { useState } from 'react';
import { AiOutlineLink } from 'react-icons/ai';
import { FaUserFriends } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';
import { ExternalLink, InvitationUser } from './components';
import { Container, Content } from './styled';

export function InvitationCall(props) {

  const { customer, onClose } = props;
  const [selected, setSelected] = useState(0);


  return (
    <Container>
      <Content isOpen={true}>
        <div className='close'>
          <IoClose className='icon' onClick={onClose} />
        </div>
        <div className='options'>
          <span
            className={selected === 0 && 'select'}
            onClick={() => setSelected(0)}
          >
            Usuários
            <FaUserFriends />
          </span>
          <span
            className={selected === 1 && 'select'}
            onClick={() => setSelected(1)}
          >
            Gerar Link
            <AiOutlineLink />
          </span>
        </div>
        <div className='body'>
          {selected === 0
            ? <InvitationUser customer={customer} />
            : <ExternalLink customer={customer} />
          }
        </div>
      </Content>
    </Container>
  );
}